import type { JSX } from 'react'
import type { IInputProps } from '../Input'

import { ButtonIconSizes } from 'atoms/Button'
import { TextBoxColors, TextBoxTypes } from 'atoms/TextBox'
import { FIXED_INDENTS } from 'vars/fixed-indents'
import { Input } from '../Input'
import {
  InputActionButtonIndent,
  InputBorders,
  InputFontColors,
  InputFonts,
  InputNames,
  InputPaddings,
} from '../Input.h'

export interface IAccountPasswordInputProps extends IInputProps {}

export const AccountPasswordInput = ({
  name = InputNames.Password,
  placeholder = '',
  placeholderColor = InputFontColors.TEXT_ICON_SECONDARY,
  label = '',
  labelFont = TextBoxTypes.FontXs,
  labelColorDefault: _unused1 = TextBoxColors.TEXT_ICON_SECONDARY,
  labelGap = FIXED_INDENTS.INDENT_10,
  iconSize = ButtonIconSizes.small,
  font = InputFonts.FontXs,
  colorDefault = InputFontColors.TEXT_ICON_PRIMARY,
  required = true,
  secured = true,
  paddings = InputPaddings.SIZE_20,
  borders = InputBorders.BORDER_10,
  inputWrapperWidth: _unused2 = '100%',
  inputWrapperHeight = '40px',
  actionButtonIndent = InputActionButtonIndent.INDENT_60,
  ...rest
}: IAccountPasswordInputProps): JSX.Element => (
  <Input
    name={name}
    placeholder={placeholder}
    placeholderColor={placeholderColor}
    label={label}
    font={font}
    colorDefault={colorDefault}
    required={required}
    secured={secured}
    paddings={paddings}
    borders={borders}
    iconSize={iconSize}
    labelFont={labelFont}
    inputWrapperHeight={inputWrapperHeight}
    actionButtonIndent={actionButtonIndent}
    labelGap={labelGap}
    {...rest}
  />
)
